import { plugin as unleashPlugin } from '@unleash/proxy-client-vue'
import { getUnleashClient } from '~/utils/unleash'

export default defineNuxtPlugin((nuxtApp) => {
  const globalStore = useGlobalStore()
  const unleashClient = getUnleashClient()
  nuxtApp.vueApp.use(unleashPlugin, { unleashClient })
  // @ts-ignore
  nuxtApp.$i18n.setLocale(globalStore.store.locale!)
  nuxtApp.vueApp.provide('unleashClient', unleashClient)
})
